// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnBox[data-v-e8c78410] {\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n.contBox > div[data-v-e8c78410] {\n  cursor: pointer;\n}\n.contBox > div[data-v-e8c78410]:hover {\n  border: 1px dashed #1890ff;\n}", ""]);
// Exports
module.exports = exports;
